import React from 'react';
import _get from 'lodash/get';
import { makeStyles } from '@material-ui/core';
import classNames from 'classnames';
import { Theme } from 'styles/ThemeTyping';
import * as Types from 'pages/Features/typings';

import Typography from '@material-ui/core/Typography';
import MetricItem from './MetricItem';
import AccessibilityIcon from '@material-ui/icons/Accessibility';
import PageviewOutlinedIcon from '@material-ui/icons/PageviewOutlined';
import TotalReportCountIcon from 'components/Icons/TotalReportCountIcon';
import Org from 'components/Icons/Org';

interface Props {
  values: Types.FeatureValues;
  view: string;
  onChange: (field: string, value: any) => void;
}

function Metrics({ values, view, onChange }: Props) {
  const classes = useStyles();

  const directReportCountOption = {
    icon: <Org className={classNames(classes.icon, classes.disabled)} />,
    displayName: 'Direct Report Count',
  };

  const options = [
    {
      icon: <TotalReportCountIcon className={classes.icon} />,
      displayName: 'Total Report Count',
      attrPath: `person.directory.orgChart.cardContent.${view}.metrics.totalReportCount`,
    },
    {
      icon: <AccessibilityIcon className={classes.icon} />,
      displayName: 'Dotted Line Report Count',
      attrPath: `person.directory.orgChart.cardContent.${view}.metrics.dottedLineRelationshipCount`,
    },
    {
      icon: <PageviewOutlinedIcon className={classes.icon} />,
      displayName: 'Open Role Report Count',
      attrPath: `person.directory.orgChart.cardContent.${view}.metrics.openRoleReportCount`,
    },
  ];

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>, attrPath: string) => {
    onChange(attrPath, event.target.checked);
  };

  return (
    <div className={classes.root}>
      <Typography variant="h6">Metrics</Typography>
      <div>
        <MetricItem
          icon={directReportCountOption.icon}
          displayName={directReportCountOption.displayName}
          disabled
          checked
        />
        {options.map((option, i) => {
          const { icon, displayName, attrPath } = option;
          return (
            <MetricItem
              key={`metric-option-${i}`}
              icon={icon}
              displayName={displayName}
              checked={_get(values, attrPath)}
              onChange={e => handleChange(e, attrPath)}
            />
          );
        })}
      </div>
    </div>
  );
}

const useStyles = makeStyles((theme: Theme) => ({
  root: {
    width: '100%',
    padding: theme.spacing(3),
  },
  icon: {
    maxHeight: 16,
    maxWidth: 16,
  },
  disabled: {
    color: theme.palette.text.gray1,
  },
}));

export default Metrics;
